/**
 * ThemeError is a generic error for the theme package.
 */
export class ThemeError extends Error {
  constructor(message: any){  
    super(message);
  }

 }
